import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const occasion = async (id) => {
  try {
    return await getData(`/without-login/allOccasion?website_type_id=${id || ""}`);
  } catch (error) {
    console.log(error);
  }
};

export const gratitude = async (id) => {
  try {
    return await getData(`/home/gratitude`);
  } catch (error) {
    console.log(error);
  }
};

export const HomeOffer = async (id) => {
  try {
    return await getData(`/policy/home-offers`);
  } catch (error) {
    console.log(error);
  }
};

export const banner = async (id) => {
  try {
    return await getData(`/home/banner`);
  } catch (error) {
    console.log(error);
  }
};

export const sustainable_products = async (id) => {
  try {
    return await getData(`/home/sustainable-products`);
  } catch (error) {
    console.log(error);
  }
};

export const promotional_products = async (id) => {
  try {
    return await getData(`/home/promotional-products`);
  } catch (error) {
    console.log(error);
  }
};

export const OccasionProducts = async (id) => {
  try {
    return await getData(`/home/occasion-products`);
  } catch (error) {
    console.log(error);
  }
};

export const blog = async (id) => {
  try {
    return await getData(`/home/promotional-products`);
  } catch (error) {
    console.log(error);
  }
};

export const bestSellingProduct = async (id) => {
  try {
    return await getData(`/without-login/all-best-selling-product`);
  } catch (error) {
    console.log(error);
  }
};



export const preferedDeliveryDate = async (id) => {
  try {
    return await getData(`/luxury/home/prefered-delivery-date`);
  } catch (error) {
    console.log(error);
  }
};
export const preferedPackaging = async (id) => {
  try {
    return await getData(`/luxury/home/packaging-preference`);
  } catch (error) {
    console.log(error);
  }
};

export const CustomisableProducts = async (id) => {
  try {
    return await getData(`/without-login/customisable-product?website_type_id=${id || ""}`);
  } catch (error) {
    console.log(error);
  }
};

